import { createFileRoute } from "@tanstack/react-router";
import { liveChannelsQueryOptions } from "~/features/live/api";
import { LiveListTemplate } from "~/features/live/LiveListTemplate";

export const Route = createFileRoute("/_authenticated/live/")({
  loader: ({ context: { queryClient } }) =>
    queryClient
      .ensureQueryData(liveChannelsQueryOptions())
      .catch(() => undefined),
  component: LiveListTemplate,
});
